import axios from './axios';

export default {
  auth: {
    token: code => axios.get(`/auth/token/${code}`).then(result => result.data),
    url: () => axios.get('/auth/url').then(result => result.data),
    revoke: () => axios.get('/auth/revoke').then(result => result.data),
    user: () => axios.get('/auth/user').then(result => result.data),
  },
  employees: {
    index: () => axios.get('/employees').then(result => result.data),
    update: (departmentId, year, month, type, value) => axios
      .put(`/employees/${departmentId}/${year}/${month}`, { [type]: value.toString().replace(',', '.') })
      .then(result => result.data),
    monthWorkHours: () => axios.get('/employees/month-work-hours').then(result => result.data),
  },
  projects: {
    index: () => axios.get('/projects').then(result => result.data),
    responsible: () => axios.get('/responsible').then(result => result.data),
    categories: {
      index: () => axios.get('/projects/categories').then(result => result.data),
    },
    statuses: {
      index: () => axios.get('/projects/statuses').then(result => result.data),
    },
    missingPlanning: () => axios.get('/projects/missing-planning').then(result => result.data),
    active: () => axios.get('/projects/active').then(result => result.data),
    create: payload => axios.post('/projects', payload).then(result => result.data),
    update: (projectId, field, value) => axios
      .put(`/projects/${projectId}`, { [field]: value })
      .then(result => result.data),
    remove: id => axios.delete(`/projects/${id}`).then(result => result.data),
  },
  departments: {
    index: () => axios.get('/departments').then(result => result.data),
    missingEmployees: () => axios.get('/departments/missing-employees').then(result => result.data),
  },
  planning: {
    index: () => axios.get('/planning').then(result => result.data),
    update: (departmentId, projectId, year, month, value) => axios
      .put(`/planning/${departmentId}/${projectId}/${year}/${month}`, { Hours: value })
      .then(result => result.data),
    remove: (departmentId, projectId, year, month) => axios
      .delete(`/planning/${departmentId}/${projectId}/${year}/${month}`)
      .then(result => result.data),
  },
};
